<template>
  <div class="altrama-extension">
    <p>Prova</p>
  </div>
</template>
<script>
//var $ = window.$;
var $ = window.jQuery;
export default{
  components: {},
  computed: {
    baseUrl: function () {
      return window.location.origin;
    },
  },

  props: ["default_attribute"],

  created() {
    console.log("Created");
    console.log(this.default_attribute);
  },

  mounted() {
    console.log("Mounted");
  },

  updated() {
    console.log("Updated");
  },

  data() {
    return {
      items: ["a", "b", "c", "d"],
      c: 0,
      choose: "Value 2",
      text: this.default_attribute,
    };
  },
  methods: {},
};
</script>


